// extracted by mini-css-extract-plugin
export default {"IntelSearchScreen":"styles_IntelSearchScreen__p95Y9"};